import ApiClient from "../helpers/ApiClient";
import useSWR from "swr";

const fetcher = (url) => ApiClient.get(url).then((res) => res.data);


export function useUsers() {
    const APIURL = `/users`;
    const { data, error, isLoading } = useSWR(APIURL, fetcher);
    return {
      data,
      error,
      isLoading,
      APIURL,
    };
  }
  

export async function addNewUser(
  username,
  password,
  name,
  designation,
  phone,
  email,
  userScopes,
  salary = 0,
  branchId = null
) {
  try {
    const response = await ApiClient.post("/users/add", {
      username,
      password,
      name,
      designation,
      phone,
      email,
      userScopes,
      salary,
      branchId
    });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function deleteUser(username) {
  try {
    const response = await ApiClient.delete(`/users/delete/${username}`)
    return response;
  } catch (error) {
    throw error;
  }
};

export async function resetUserPassword(username, password) {
  try {
    const response = await ApiClient.post(`/users/update-password/${username}`, {
      password
    })
    return response;
  } catch (error) {
    throw error;
  }
};

export async function updateUser(
  username,
  name,
  designation,
  phone,
  email,
  userScopes,
  salary = 0,
  branchId = null
) {
  try {
    const response = await ApiClient.post(`/users/update/${username}`, {
      name,
      designation,
      phone,
      email,
      userScopes,
      salary,
      branchId
    });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function processBulkPayroll() {
  try {
    const response = await ApiClient.post("/users/payroll/process");
    return response;
  } catch (error) {
    throw error;
  }
}

export async function resetBulkPayroll() {
  try {
    const response = await ApiClient.post("/users/payroll/reset");
    return response;
  } catch (error) {
    throw error;
  }
}

export async function updateUserPayrollStatus(username, payrollStatus) {
  try {
    const response = await ApiClient.post(`/users/payroll/status/${username}`, {
      payrollStatus
    });
    return response;
  } catch (error) {
    throw error;
  }
}
